import React from 'react'
import { Input } from 'antd';
import { SearchOutlined } from "@ant-design/icons";

type Props = {
  placeholder?: string;
  value?: string;
  className?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onSearch?: React.KeyboardEventHandler<HTMLInputElement>;
}

export default function AppSearch({ placeholder, value, className, onChange, onBlur, onSearch }: Props) {

  return (
    <Input
      className={className}
      value={value}
      placeholder={placeholder || "Search elements..."}
      allowClear
      onChange={onChange}
      onBlur={onBlur}
      onPressEnter={onSearch}
      prefix={<SearchOutlined />}
    />
  )
}
